import "core-js/modules/es.array.includes.js";
import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-a96b2f2a"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "step-warp"
};
const _hoisted_2 = {
  class: "info-warp"
};
const _hoisted_3 = {
  class: "tree-warp"
};
const _hoisted_4 = {
  class: "header"
};
const _hoisted_5 = {
  class: "tree-info"
};
const _hoisted_6 = {
  class: "select-warp"
};
const _hoisted_7 = {
  class: "header"
};
const _hoisted_8 = {
  class: "title-name"
};
const _hoisted_9 = {
  class: "select-list"
};
const _hoisted_10 = {
  class: "select-item"
};
const _hoisted_11 = ["onClick"];
const _hoisted_12 = {
  key: 1,
  class: "empty"
};
import SearchInput from '@/components/SearchInput/index.vue';
import { getCurrentInstance, nextTick, reactive, inject } from 'vue';
import { getAgentCategoryApi } from '@/api/vodNew';
export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    programType: {
      type: Number,
      default: 0
    }
  },

  setup(__props, {
    expose
  }) {
    const props = __props;
    const {
      proxy
    } = getCurrentInstance();
    const defaultProps = {
      children: 'children',
      label: 'name',
      disabled: 'disabled'
    };
    const finishData = inject('finishData');
    const dataInfo = reactive({
      list: [],
      selectList: [],
      showLoading: false
    });
    expose({
      dataInfo
    }); // 搜索框配置

    const searchConfig = reactive({
      formData: {
        keyword: ''
      },
      formList: [{
        label: '关键字',
        prop: 'keyword',
        widgetType: 'input',
        placeholder: '请输入关键字',
        style: "width: 260px"
      }],
      search: () => {}
    });

    const filterNode = (value, data) => {
      if (!value) return true;
      return data.name.includes(value);
    }; //递归设置父节点全部选中


    const setParentNode = node => {
      if (node.parent) {
        for (const key in node) {
          if (key === 'parent') {
            node[key].checked = true;
            setParentNode(node[key]);
          }
        }
      }
    }; // 递归设置子节点全部取消选中


    const setChildNode = node => {
      if (node.childNodes && node.childNodes.length) {
        if (!node.checked) {
          node.childNodes.forEach(item => {
            item.checked = false;
            setChildNode(item);
          });
        } else {
          node.childNodes.forEach(item => {
            item.checked = true;
            setChildNode(item);
          });
        }
      }
    };

    const treeRef = ref();

    const handleSearch = data => {
      treeRef.value.filter(data.keyword);
    };

    const handleReset = () => {
      treeRef.value.filter();
    }; // 复选框点击事件


    const handleCheck = (data, change) => {
      const treeRef = proxy.$refs.treeRef;
      let nodes = treeRef.getCheckedNodes().concat(treeRef.getHalfCheckedNodes());
      let filterNodes = nodes.filter(node => {
        return node.children === null;
      });
      dataInfo.selectList = filterNodes; // 赋值给表格数据
    }; // 删除按钮


    const deleteRow = (index, id) => {
      const treeRef = proxy.$refs.treeRef;
      treeRef.setChecked(id, false); // 取消左侧复选框的选中状态

      dataInfo.selectList.splice(index, 1); // 从tableData中删除数据
    }; // 复选框默认选中状态,应在请求数据处调用
    // 现在用的是本地数据，如果导入的是请求后的来的数据，并且有返回是否选中的字段，可以将已选中的那些数据的id遍历出来一个数组，类似于[1,2,3],然后放到下方；


    const selection = arrDa => {
      nextTick(() => {
        const treeRef = proxy.$refs.treeRef;
        arrDa && arrDa.length && treeRef.setCheckedKeys(arrDa, true); // 默认选中状态
      });
    };

    const getCategoryList = async () => {
      dataInfo.showLoading = true;
      dataInfo.selectList = [];
      const cid = sessionStorage.getItem('currentCid');
      let videoType = [0, 1];
      let params = {
        //videoType: videoType,
        cid: cid,
        type: 2,
        isFilterRelationAgent: true
      };
      const res = await getAgentCategoryApi(params);
      let tempList = [];

      if (res.code == '0') {
        res.data.forEach(item => {
          if (!item.children || !item.children.length) {
            item.disabled = true;
          } else {
            setParentName(item.name, item, tempList);
          }
        });
        dataInfo.list = res.data;
        finishData.value.categoryIdList.forEach(item => {
          let selectItem = tempList.find(tempItem => tempItem.id === item);

          if (selectItem) {
            dataInfo.selectList.push(selectItem);
          }
        });
      }

      selection(finishData.value.categoryIdList);
      dataInfo.showLoading = false;
    }; // 设置右侧选择列表回显数据


    const setParentName = (masterName, obj, arr) => {
      obj.children.forEach(child => {
        child.subBrandName = obj.name;
        child.masterBrandName = masterName;
        arr.push(child);

        if (child.children) {
          setParentName(masterName, child, arr);
        }
      });
    };

    getCategoryList();
    return (_ctx, _cache) => {
      const _component_el_tree = _resolveComponent("el-tree");

      const _directive_loading = _resolveDirective("loading");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(SearchInput, {
        class: "search-input",
        labelWidth: "120px",
        size: {
          xs: 24,
          sm: 24,
          md: 12,
          lg: 12,
          xl: 12
        },
        "form-list": searchConfig.formList,
        "form-data": searchConfig.formData,
        onSearch: handleSearch,
        onReset: handleReset
      }, null, 8, ["form-list", "form-data"]), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('分类列表')), 1), _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_5, [_createVNode(_component_el_tree, {
        ref_key: "treeRef",
        ref: treeRef,
        "node-key": "id",
        "default-checked-keys": dataInfo.list,
        "default-expand-all": "",
        data: dataInfo.list,
        props: defaultProps,
        "filter-node-method": filterNode,
        "show-checkbox": "",
        onCheck: handleCheck
      }, null, 8, ["default-checked-keys", "data"])])), [[_directive_loading, dataInfo.showLoading]])]), _createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$t('已选分类列表')), 1), _createElementVNode("div", _hoisted_8, [_createElementVNode("span", null, _toDisplayString(_ctx.$t('主品牌名称')), 1), _createElementVNode("span", null, _toDisplayString(_ctx.$t('子品牌名称')), 1), _createElementVNode("span", null, _toDisplayString(_ctx.$t('分类名称')), 1), _createElementVNode("span", null, _toDisplayString(_ctx.$t('操作')), 1)]), _createElementVNode("div", _hoisted_9, [dataInfo.selectList.length > 0 ? (_openBlock(true), _createElementBlock(_Fragment, {
        key: 0
      }, _renderList(dataInfo.selectList, (item, index) => {
        return _openBlock(), _createElementBlock("div", {
          key: index
        }, [_createElementVNode("div", _hoisted_10, [_createElementVNode("span", null, _toDisplayString(item.masterBrandName), 1), _createElementVNode("span", null, _toDisplayString(item.subBrandName), 1), _createElementVNode("span", null, _toDisplayString(item.name), 1), _createElementVNode("span", null, [_createElementVNode("span", {
          class: "delete",
          onClick: $event => deleteRow(index, item.id)
        }, _toDisplayString(_ctx.$t('删除')), 9, _hoisted_11)])])]);
      }), 128)) : (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(_ctx.$t('暂无数据')), 1))])])])]);
    };
  }

});